import { ISelectOptions } from "../components/ui-components/Select";
import { CountryCodeEnum } from "../enums/country-code-enum";

export const getCountryName = (countryCode: String) => {
  switch (countryCode) {
    case CountryCodeEnum.UnitedStates:
      return "United States";
    case CountryCodeEnum.GreatBriton:
      return "Great Britain";
    case CountryCodeEnum.France:
      return "France";
    case CountryCodeEnum.Denmark:
      return "Denmark";
    case CountryCodeEnum.Canada:
      return "Canada";
    case CountryCodeEnum.Spain:
      return "Spain";
    case CountryCodeEnum.Nepal:
      return "Nepal";
    default:
      return "";
  }
};

export const countryOptions: ISelectOptions[] = [
  {
    title: "None",
    value: "",
  },
  {
    title: "United States",
    value: CountryCodeEnum.UnitedStates,
  },
  {
    title: "Great Briton",
    value: CountryCodeEnum.GreatBriton,
  },
  {
    title: "Canada",
    value: CountryCodeEnum.Canada,
  },
  {
    title: "Denmark",
    value: CountryCodeEnum.Denmark,
  },
  {
    title: "France",
    value: CountryCodeEnum.France,
  },
  {
    title: "Spain",
    value: CountryCodeEnum.Spain,
  },
  {
    title: "Nepal",
    value: CountryCodeEnum.Nepal,
  },
];
